import { InvoiceItem } from 'features/Invoicing/components/Invoices/Invoice/Invoice.types'

interface GetIsCatalogItemModifiedProps {
  item: InvoiceItem
  hasError: boolean
}

export const getIsCatalogItemAndModified = ({
  item,
  hasError,
}: GetIsCatalogItemModifiedProps) => {
  const {
    catalogItemUuid,
    description,
    initialDescription,
    initialName,
    initialPrice,
    name,
    price,
  } = item

  if (!catalogItemUuid || hasError) {
    return false
  }

  const hasDescriptionChanged = description.trim() !== initialDescription.trim()
  const hasNameChanged = name.trim() !== initialName.trim()

  const hasPriceChanged = initialPrice.intValue !== price.intValue

  return hasDescriptionChanged || hasNameChanged || hasPriceChanged
}
